export default __webpack_public_path__ + "static/media/AtlasLogoMain.2eebe8e3.png";